module.exports = __webpack_public_path__ + "static/media/bg-bubbles.f17587b9.svg";